import { useState, useEffect, useMemo, useCallback } from "react";
import { Row, Col, Card, Form, Alert } from "react-bootstrap";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { format } from "rut.js";
import _ from "lodash";
import { useLocation } from "react-router-dom";

import { integerValidate } from "@/services/Utils";

import classes from "./createOrderDelivery.module.scss";
import { useOrderDeliveryCreate } from "@/hooks/purchases/orders_delivery";
import { customStyles } from "./createOrderDelivery.constants";

import api from "@/services/api.service";
import { validateExistenceOrderDelivery } from "@/api/Purchases/orders_delivery";
import { useSelector } from "react-redux";
import { textConstants } from "@/languages/textConstants";

import { NoOptionsMessage } from "@/components/ReactSelect/NoOptions";
import CustomDateInput from "@/components/desktop/form/input/input-date/CustomDateInput";
import InputExchange from "@/components/Form/Exchange/InputExchange";

const CreateOrderDeliveryTableDetail = ({ params, data, setData, setIsFetchingDetail, checkDetailOC, handleValidPrice }) => {
	let location = useLocation();
	const { data: response } = useOrderDeliveryCreate(params);
	const { business, estates_parents, estates, types_currency, orders, orders_sale } = response;

	const { customer } = useSelector((state) => state.auth.user);

	const [activeDetail, setActiveDetail] = useState(true);
	const [dealers, setDealers] = useState([]);
	const [products_generic, setProductsGeneric] = useState([]);
	const [deliveryExistence, setDeliveryExistence] = useState([]);

	useEffect(() => {
		if (response) {
			setDealers(response.dealers);
			setProductsGeneric(response.products_generic);
		}
	}, [response]);

	const handleChangeDealer = (opt) => {
		const dealer = dealers.find((d) => d.value === opt.value);

		if (!dealer) {
			let newDealers = [...dealers];
			const newDealer = {
				value: opt.value,
				label: opt.value,
			};

			newDealers.push(newDealer);
			setDealers(newDealers);
		}

		handleValidExistence(opt.value, data.delivery_number);

		setData({
			...data,
			dealer_id: opt.value,
			rut_dealer: dealer ? dealer.rut_dealer : "",
		});
	};

	const handleChangeDeliveryNumber = (value) => {
		setData({
			...data,
			delivery_number: value,
		});
	};

	const handleOrders = (value) => {
		checkDetailOC(value);
	};

	const handleOrdersSale = (value) => {
		const orders_ids = _.map(value, "value");
		const dealers_ids = _.map(value, "dealer_id");
		const ruts_ids = _.map(value, "rut_dealer");

		setIsFetchingDetail(true);
		api.get("/client/orders_sale/detail", {
			orders_sale: orders_ids.toString(),
			order_delivery_id: data.id,
			type: "orders_delivery_detail",
		}).then((response) => {
			let newItems = [...data.items];
			newItems = newItems.filter((ni) => ni.product_id !== "");

			if (response) {
				response.items.forEach((element) => {
					const existInItems = data.items.find((it) => Number(it.order_sale_detail_id) === Number(element.order_sale_detail_id));
					if (!existInItems) {
						newItems.push(element);
					}
				});
			}

			setData({
				...data,
				orders_sale_code: orders_ids,
				dealer_id: dealers_ids[0],
				rut_dealer: ruts_ids[0],
				items: newItems,
				productCustomer: products_generic,
			});
			setIsFetchingDetail(false);
		});
	};

	const handleValidExistence = useCallback(
		async (dealer_id, delivery_number) => {
			let existDelivery = [];
			if (dealer_id && delivery_number) {
				setIsFetchingDetail(true);
				existDelivery = await validateExistenceOrderDelivery(data.id, dealer_id, delivery_number);
				setIsFetchingDetail(false);
			}

			setDeliveryExistence(existDelivery);
		},
		[data.id, setIsFetchingDetail],
	);

	const delayedQuery = useMemo(
		() =>
			_.debounce((data, value) => {
				handleValidExistence(data.dealer_id, value);
			}, 500),
		[handleValidExistence],
	);

	useEffect(() => {
		return () => {
			delayedQuery.cancel();
		};
	}, [delayedQuery]);

	const setDelayDeliveryNumber = (value) => {
		handleChangeDeliveryNumber(value);
		delayedQuery(data, value);
	};

	const selectEstateParent = estates_parents.find((e) => String(e.value) === String(data.estate_parent_id));
	const selectEstate = estates.find((e) => String(e.value) === String(data.estate_id));
	const selectDealer = dealers.find((d) => String(d.value) === String(data.dealer_id));

	return (
		<Col md={12} className={classes.col_base}>
			<Card className={activeDetail && "active"}>
				<Card.Header onClick={() => setActiveDetail(!activeDetail)} className={activeDetail && "active"}>
					Detalle
					<div>
						{!!customer.use_estates_parents && (
							<span style={{ marginRight: "1em" }}>
								<strong>
									{customer.customer_screens.find((cs) => cs.screen_id === 38)
										? customer.customer_screens.find((cs) => cs.screen_id === 38)?.name
										: "Grupo Campo"}
									:
								</strong>
								{` ${selectEstateParent ? selectEstateParent.label : ""}`}
							</span>
						)}
						<span style={{ marginRight: "1em" }}>
							<strong>
								{customer.customer_screens.find((cs) => cs.screen_id === 51)
									? customer.customer_screens.find((cs) => cs.screen_id === 51)?.name
									: "Campo"}
								:
							</strong>
							{` ${selectEstate ? selectEstate.label : ""}`}
						</span>
						{!location.pathname.includes("sin_documento") && (
							<>
								<span style={{ marginRight: "1em" }}>
									<strong> Distribuidor:</strong>
									{` ${selectDealer ? selectDealer.label : ""}`}
								</span>
								<span>
									<strong> N° {textConstants[customer.country_id].delivery}:</strong>
									{` ${data.delivery_number ? data.delivery_number : ""}`}
								</span>
							</>
						)}
					</div>
				</Card.Header>
				{activeDetail && (
					<Card.Body>
						{deliveryExistence.length !== 0 && (
							<Alert variant="warning" onClose={() => setDeliveryExistence([])} dismissible>
								<Alert.Heading style={{ fontSize: "15px" }}>{textConstants[customer.country_id].delivery} existente</Alert.Heading>
								<ul>
									{deliveryExistence.map((se, i) => {
										let link = `/guias_despacho/editar/${se.code}`;

										return (
											<li key={i}>
												El número de {textConstants[customer.country_id].delivery}{" "}
												<a href={link} target="_blank" rel="noopener noreferrer">
													{se.delivery_number}
												</a>{" "}
												del distribuidor {selectDealer.label} ya ha sido ingresado.
											</li>
										);
									})}
								</ul>
								puede cerrar esta alerta y continuar de todas formas.
							</Alert>
						)}

						<Row className={classes.header}>
							<Col md={6} sm={12} className={classes.headerLeft}>
								<div className={classes.divInput}>
									<div className={classes.inputForm}>
										<div className={classes.inputText}>Razón Social</div>
										<div>
											<Select
												value={business && business.filter((b) => Number(b.value) === Number(data.business_id))}
												placeholder={<div>Seleccione</div>}
												options={business}
												onChange={(value) =>
													setData({
														...data,
														business_id: value.value,
													})
												}
											/>
										</div>
									</div>

									{!!customer.use_estates_parents && (
										<div className={classes.inputForm}>
											<div className={classes.inputText}>
												{customer.customer_screens.find((cs) => cs.screen_id === 38)
													? customer.customer_screens.find((cs) => cs.screen_id === 38)?.name
													: "Grupo Campo"}
											</div>
											<div>
												<Select
													value={estates_parents && estates_parents.filter((b) => Number(b.value) === Number(data.estate_parent_id))}
													placeholder={<div>Seleccione</div>}
													options={estates_parents}
													onChange={(value) =>
														setData({
															...data,
															estate_parent_id: value ? value.value : "",
															estate_id: "",
														})
													}
													isClearable={true}
												/>
											</div>
										</div>
									)}

									<div className={classes.inputForm}>
										<div className={classes.inputText}>
											{customer.customer_screens.find((cs) => cs.screen_id === 51)
												? customer.customer_screens.find((cs) => cs.screen_id === 51)?.name
												: "Campo"}
										</div>
										<div>
											<Select
												value={estates && estates.filter((b) => String(b.value) === String(data.estate_id))}
												placeholder={<div>Seleccione</div>}
												options={
													data.estate_parent_id
														? estates.filter((e) => String(e.estate_parent_id) === String(data.estate_parent_id))
														: estates
												}
												onChange={(value) => {
													const newItems = data.items.map((item) => ({
														...item,
														save_as: "",
													}));

													setData({
														...data,
														items: newItems,
														estate_id: value ? value.value : "",
														estate_parent_id: value ? value.estate_parent_id : data.estate_parent_id ? data.estate_parent_id : "",
													});
												}}
												isClearable={true}
											/>
										</div>
									</div>

									{!location.pathname.includes("sin_documento") && (
										<Row>
											<Col md={6}>
												<div className={classes.inputForm}>
													<div className={classes.inputText}>Distribuidor</div>
													<div>
														<CreatableSelect
															value={dealers && dealers.filter((d) => String(d.value) === String(data.dealer_id))}
															options={dealers}
															formatCreateLabel={(value) => {
																return `Crear ${value}`;
															}}
															components={{
																NoOptionsMessage,
															}}
															placeholder={""}
															onChange={(opt) => handleChangeDealer(opt)}
														/>
													</div>
												</div>
											</Col>

											<Col md={6}>
												<div className={classes.inputForm}>
													<div className={classes.inputText}>RUT</div>
													<div>
														<Form.Control
															style={{
																padding: "6px",
															}}
															onChange={(e) =>
																setData({
																	...data,
																	rut_dealer: format(e.target.value),
																})
															}
															type="text"
															value={data.rut_dealer ? format(data.rut_dealer) : ""}
														/>
													</div>
												</div>
											</Col>
										</Row>
									)}
								</div>
							</Col>

							<Col md={6} sm={12} className={classes.headerRight}>
								<div className={classes.divInput}>
									{!location.pathname.includes("sin_documento") && (
										<>
											<Row>
												<Col md={6}>
													<div className={classes.inputForm}>
														<div className={classes.inputText}>Número {textConstants[customer.country_id].delivery}</div>
														<div>
															<Form.Control
																style={{
																	padding: "6px",
																}}
																onChange={(e) => setDelayDeliveryNumber(e.target.value)}
																type="text"
																onKeyDown={integerValidate}
																value={data.delivery_number ? data.delivery_number : ""}
															/>
														</div>
													</div>
												</Col>

												<Col md={6}>
													<div className={classes.inputForm}>
														<div className={classes.inputText}>Fecha {textConstants[customer.country_id].delivery}</div>
														<div>
															<CustomDateInput
																value={data && data.date_orders_delivery}
																setValue={(index, value) => {
																	setData({
																		...data,
																		date_orders_delivery: value,
																		date_calculate: value,
																		exchange_rate_type: "delivery",
																	});
																}}
															/>
														</div>
													</div>
												</Col>
											</Row>

											<Row>
												<Col md={12}>
													<div className={classes.inputForm}>
														<div className={classes.inputText}>Ordenes de Compra</div>
														<div>
															<Select
																styles={customStyles}
																value={
																	orders &&
																	orders.filter((a) => {
																		const codes =
																			typeof data?.orders_code === "string"
																				? data.orders_code.split(",").map((s) => s.trim())
																				: [data?.orders_code].flat().map(String);

																		return codes.includes(a.value.toString());
																	})
																}
																isMulti
																placeholder={<div>Seleccione</div>}
																options={
																	orders
																		? data.dealer_id
																			? orders.filter(
																					(co) =>
																						co.dealer_id === data.dealer_id && co.business_id === data.business_id,
																				)
																			: orders.filter((co) => co.business_id === data.business_id)
																		: []
																}
																onChange={(value) => handleOrders(value)}
																isDisabled={data.orders_sale_code && data.orders_sale_code.length > 0 ? true : false}
																components={{
																	NoOptionsMessage,
																}}
															/>
														</div>
													</div>
												</Col>
											</Row>

											<Row>
												<Col md={12}>
													<div className={classes.inputForm}>
														<div className={classes.inputText}>Facturas</div>
														<div>
															<Select
																styles={customStyles}
																value={
																	orders_sale &&
																	orders_sale.filter(
																		(a) =>
																			data &&
																			data.orders_sale_code &&
																			data.orders_sale_code.length > 0 &&
																			[data.orders_sale_code].flat().map(String).includes(a.value.toString()),
																	)
																}
																isMulti
																placeholder={<div>Seleccione</div>}
																options={
																	orders_sale
																		? data.dealer_id
																			? orders_sale.filter(
																					(co) =>
																						co.dealer_id === data.dealer_id && co.business_id === data.business_id,
																				)
																			: orders_sale.filter((co) => co.business_id === data.business_id)
																		: []
																}
																onChange={(value) => handleOrdersSale(value)}
																isDisabled={data.orders_code && data.orders_code.length > 0 ? true : false}
																components={{
																	NoOptionsMessage,
																}}
															/>
														</div>
													</div>
												</Col>
											</Row>
										</>
									)}

									<Row>
										<Col md={6}>
											<div className={classes.inputForm}>
												<div className={classes.inputText}>Moneda</div>
												<div>
													<Select
														value={
															types_currency && types_currency.filter((b) => String(b.value) === String(data.type_currency_id))
														}
														placeholder={<div>Seleccione</div>}
														options={types_currency}
														onChange={(value) => {
															setData({
																...data,
																type_currency_id: value.value,
															});

															handleValidPrice(null, null, value.value);
														}}
													/>
												</div>
											</div>
										</Col>

										<Col md={6}>
											<div className={classes.inputForm}>
												<div className={classes.inputText}>Tipo de Cambio</div>

												<InputExchange data={data} setData={setData} />
											</div>
										</Col>
									</Row>
								</div>
							</Col>
						</Row>
					</Card.Body>
				)}
			</Card>
		</Col>
	);
};

export default CreateOrderDeliveryTableDetail;
